<div class="BagsRedemptionModal">
  <div class="BagsRedemptionModal-close">
    <img alt="" src="../../../../assets/images/close.svg" (click)="onClose()" />
  </div>
  <div class="BagsRedemptionModal-container text-center">
    <img alt="" class="BagsRedemptionModal-image" [src]="modalImageSrc" />

    <!-- CI-19584: para target='carryon' no se muestra el pre-título de checked -->
    <p *ngIf="target !== 'carryon'" class="fs-20px lh-34px fw-regular mb-1">
      {{ modalTitleBefKey | translate }}
    </p>
    <p [innerHTML]="modalTitleKey | translate" class="fs-36px lh-52px fw-medium-x"></p>
    <!-- CI-19584: subtítulo Carry-On con peso dinámico (0CZ→10, 07X→15) -->
    <p *ngIf="target === 'carryon'" class="fs-20px lh-34px fw-regular mb-1">
      {{ 'modalbagsredemption.carryonSubtitle' | translate : { weight: carryonWeightKg } }}
    </p>
    <!-- subtítulo legacy "Selecciona un método": solo cuando hay radios (checked) -->
    <p
      *ngIf="showMethodRadios"
      id="benefitMethodGroupLabel"
      class="fs-20px lh-34px fw-regular mb-1"
    >
      {{ 'modalbagsredemption.subtitleNxt' | translate }}
    </p>

    <div
      *ngIf="
        showMethodRadios &&
        (passenger.typeCobrand == 'cobrand' ||
          passenger.typeTier == 'tier' ||
          passenger.typeTier == 'corporate')
      "
      class="Box-befefit"
    >
      <fieldset class="radio-cards" role="radiogroup" aria-labelledby="benefitMethodGroupLabel">
        <!-- Opción: por nivel (tier) -->
        <ng-container *ngIf="passenger?.typeTier === 'tier'">
          <input
            class="radio-cards__input"
            type="radio"
            id="benefit-tier"
            name="benefitMethod"
            [value]="'tier'"
            [(ngModel)]="selectedMethod"
          />
          <label class="radio-cards__card" for="benefit-tier">
            <div class="radio-cards__bullet" aria-hidden="true"></div>
            <div class="radio-cards__content">
              <p class="txt-radiob fw-regular mb-1">
                {{ 'modalbagsredemption.nivel' | translate }}
              </p>
              <span class="one-line">
                <b>{{ 'modalbagsredemption.titleCardOne' | translate }}</b>
                <span
                  *ngIf="passenger?.benefits?.tier"
                  [ngClass]="['passenger-benefit', 'passenger-benefit--' + classTier]"
                >
                  {{ passenger?.benefits?.tier }}
                </span>
              </span>
              <div class="poss-img">
                <img class="Sz-img" alt="Rewards" src="./assets/images/AeroméxicoRewards.svg" />
              </div>
            </div>
          </label>
        </ng-container>
        <div class="divi-card"></div>
        <!-- Opción: por tarjeta (cobrand) -->
        <ng-container *ngIf="passenger?.typeCobrand === 'cobrand'">
          <input
            class="radio-cards__input"
            type="radio"
            id="benefit-cobrand"
            name="benefitMethod"
            [value]="'cobrand'"
            [(ngModel)]="selectedMethod"
          />
          <label class="radio-cards__card" for="benefit-cobrand">
            <div class="radio-cards__bullet" aria-hidden="true"></div>
            <div class="radio-cards__content">
              <p class="txt-radiob fw-regular mb-1">
                {{ 'modalbagsredemption.card' | translate }}
              </p>
              <p>
                <b>{{ 'modalbagsredemption.titleCardTwo' | translate }}</b>
              </p>
              <div class="poss-img">
                <img class="Sz-img" alt="AMEX" src="./assets/images/amex.svg" />
              </div>
            </div>
          </label>
        </ng-container>
        <ng-container *ngIf="passenger?.typeCorporate === 'corporate'">
          <input
            class="radio-cards__input"
            type="radio"
            id="benefit-corporate"
            name="benefitMethod"
            [value]="'corporate'"
            [(ngModel)]="selectedMethod"
          />
          <label class="radio-cards__card" for="benefit-corporate">
            <div class="radio-cards__bullet" aria-hidden="true"></div>
            <div class="radio-cards__content">
              <p class="txt-radiob fw-regular mb-1">
                {{ 'modalbagsredemption.card' | translate }}
              </p>
              <p>
                <b>{{ 'modalbagsredemption.titleCardTwo' | translate }}</b>
              </p>
              <div class="poss-img">
                <img class="Sz-img" alt="Rewards" src="./assets/images/AeroméxicoRewards.svg" />
              </div>
            </div>
          </label>
        </ng-container>
      </fieldset>
    </div>

    <div class="Btnsmodal gapline">
      <button class="BagsRedemptionModal-btnBenefit2" (click)="onClose()">
        {{ modalNoAcceptKey | translate }}</button
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button
        class="BagsRedemptionModal-btnBenefit"
        (click)="onRedeem()"
        [disabled]="selectedMethod == null"
      >
        {{ 'modalbagsredemption.Accept' | translate }}
        <div class="loading-component" *ngIf="showLoading"></div>
      </button>
    </div>
  </div>
</div>
